module.exports = __webpack_public_path__ + "static/media/banner-4.baf00476.jpg";